var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-3 has-text-centered box-zooms-on-hover is-relative",attrs:{"data-aos":"fade-in","data-aos-easing":"linear"}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"size":"3x"}}),_c('hr'),_c('h2',{staticClass:"title is-4 has-text-white is-marginless"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }